
import { PublicClientApplication } from '@azure/msal-browser';
import { environment } from 'src/environments/environment';

export const msalInstance = new PublicClientApplication({
  auth: {
    clientId: '7059ab5c-1b6a-4a5f-9897-ac711453e7d6',
    authority: 'https://login.microsoftonline.com/3bc062e4-ac9d-4c17-b4dd-3aad637ff1ac',
    redirectUri: environment.urlLogin
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: false
  }
});